<template>
    <div class="tab-content" v-if="expensePolicy">
        <template v-if="expensePolicy.paymentRule">
            <h4 class="title">付费规则：</h4>
            <p v-html="expensePolicy.paymentRule"></p>
        </template>
        <template v-if="expensePolicy.escheatageRule">
            <h4 class="title">归属权判定规则：</h4>
            <p v-html="expensePolicy.escheatageRule"></p>
        </template>
        <template v-if="expensePolicy.orderRule">
            <h4 class="title">做单规则：</h4>
            <p v-html="expensePolicy.orderRule"></p>
        </template>
        <template v-if="expensePolicy.supplementaryInformation">
            <h4 class="title">补充信息：</h4>
            <p v-html="expensePolicy.supplementaryInformation"></p>
        </template>
    </div>
</template>

<script>
  export default {
    props: {
      expensePolicy:{}
    },
    data() {
      return {
        
      }
    },
  };
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.tab-content{
    .title{
        font-weight: bold;
        margin-bottom: 10px;
    }
    p{
        margin-bottom: 10px;
        white-space: pre-line;
        word-break: break-all;
    }
}
</style>
